import * as util from './syllabus-block-utils';
import Block from './block';

export default {
  props: util.props,
  template: '#video-block-template',
  data() {
    return Object.assign( {
      title: '',
      file: null,
      contentSize: 0,
      contentName: '',
      removeContent: false,
    }, this.rootData);
  },
  components: {
    Block
  },
  watch: {
    dataForSave() {
      this.$emit('block-update', this.dataForSave);
    },
  },
  computed: {
    isEmpty() {
      return _.isEmpty(this.file);
    },
    videoPlayerID() {
      return util.generateID('video-player');
    },
    dzID: util.dzID,
    dataForSave() {
      return {
        uuid: this.uuid,
        data: {
          title: this.title,
          file: this.file,
          contentName: this.contentName,
          contentSize: this.contentSize,
          removeContent: this.removeContent,
          showOnPublicSyllabus: this.showOnPublicSyllabus
        }
      };
    }
  },
  methods: {
    initVideoPlayer() {
      this.videoPlayer = new Kadenze.VideoPlayer(
        $(this.$refs.videoPlayerEle),
        {
          path: this.file.url,
          h264_360_url: this.file.url,
          h264_720_url: this.file.url,
        },
        'vjs-instructor-skin'
      );
    },
    initDropzone() {
      const maxFilesize = 2000;
      const acceptedFiles = 'video/*, video/mp4';

      const message = JST['templates/dropzone-generic']({
        maxFilesize,
        dropFilesTitle: Kadenze.I18n.t('drop_file_editor.drop_file_title'),
        dragAndDrop: Kadenze.I18n.t('drop_file_editor.drag_and_drop'),
        browseFiles: Kadenze.I18n.t('drop_file_editor.browse_files'),
        dimentionLabel: Kadenze.I18n.t('drop_file_editor.dimensions_label'),
        maxFilesizeLabel: Kadenze.I18n.t('drop_file_editor.max_file_size'),
        fileTypesLabel: Kadenze.I18n.t('drop_file_editor.file_types'),
        optionalLable: Kadenze.I18n.t('drop_file_editor.optional'),
        acceptedFiles
      });

      const $previewTemplate = $(Kadenze.I18n.tt(JST['templates/dropzone-media-preview']({
        status: this.file ? '' : 'uploading',
        previewable: false
      })));
      const opts = {
        url: Kadenze.Routes.course_syllabus_blocks_path(this.$root.course.id),
        previewContainer: this.$refs.previewContainer,
        previewTemplate: $previewTemplate[0].outerHTML,
        autoProcessQueue: true,
        acceptedFiles,
        maxFilesize,
        previewable: false
      };

      const callbacks = {
        success: (file, { block }) => {
          this.bindFile(file, block);
          this.$emit('set-block-id', { uuid: this.uuid, id: block.id });

          this.initVideoPlayer();
        },
        uploadprogress: (file, progress, bytesSent) => {
          $('.media-upload-progress-bar', file.previewTemplate).css('width', progress + '%');
        },
        error: (file, errorMessage) => {
          new Kadenze.Notice.error({ message: errorMessage });
          this.$refs.dzEle.dropzone.removeAllFiles();
        },
        removedfile: (file) => {
          this.file = null;
          this.removeContent = true;
        },
        complete: (file) => {
          $('.media-upload-progress-bar-container', file.previewTemplate).hide();
          $('.label-uploading', file.previewTemplate).hide();
        }
      };

      this.dropzone = new Kadenze.MediaDropZone(
        this.$refs.dzEle,
        $(message),
        opts,
        callbacks,
        false,
        this.curFileObj()
      );
    },
    bindFile: util.bindFile,
    curFileObj: util.curFileObj
  },
  mounted() {
    if(this.curFileObj()) {
      this.initVideoPlayer();
    }
    this.initDropzone();
  },
};
